// extracted by mini-css-extract-plugin
module.exports = {"issuesTitle":"styles_issuesTitle__lniWy","enrollmentsIssues":"styles_enrollmentsIssues__2rytc","item":"styles_item__2-2KE","icon":"styles_icon__29AWH"};